// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__+SVms","active":"Tab_active__g2ANK"};